'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SaveSearchRemote = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveSearchRemote = exports.SaveSearchRemote = {
    deleteSavedSearch: function deleteSavedSearch(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            savedSearchId = _ref.savedSearchId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeDelete)('<SAVED-SEARCH-API>searches/' + savedSearchId, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSavedSearches: function fetchSavedSearches(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>savedsearch/searches', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSavedSearchItems: function fetchSavedSearchItems(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>savedsearch/items', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postDeleteSavedSearches: function postDeleteSavedSearches(_ref4) {
        var authToken = _ref4.authToken,
            deployment = _ref4.deployment,
            savedSearchIds = _ref4.savedSearchIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>savedsearch/delete', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: savedSearchIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postIsSavedSearch: function postIsSavedSearch(_ref5) {
        var authToken = _ref5.authToken,
            deployment = _ref5.deployment,
            searchParams = _ref5.searchParams;
        return new _promise2.default(function (resolve, reject) {
            var encodedSearch = encodeURIComponent((0, _stringify2.default)(searchParams));
            var request = (0, _helpers.makePost)('<SAVED-SEARCH-API>searches/' + encodedSearch, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send(encodedSearch);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, success404: true });
            });
        });
    },
    postSaveSearch: function postSaveSearch(_ref6) {
        var authToken = _ref6.authToken,
            deployment = _ref6.deployment,
            searchParams = _ref6.searchParams,
            sendalert = _ref6.sendalert;
        return new _promise2.default(function (resolve, reject) {
            var facets = (0, _extends3.default)({}, searchParams);
            var request = (0, _helpers.makePost)('<SAVED-SEARCH-API>searches', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ facets: facets, sendalert: sendalert });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postSubscribeToSavedSearches: function postSubscribeToSavedSearches(_ref7) {
        var authToken = _ref7.authToken,
            deployment = _ref7.deployment,
            savedSearchIds = _ref7.savedSearchIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>savedsearch/subscribe', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: savedSearchIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postUnsubscribeFromSavedSearches: function postUnsubscribeFromSavedSearches(_ref8) {
        var authToken = _ref8.authToken,
            deployment = _ref8.deployment,
            savedSearchIds = _ref8.savedSearchIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>savedsearch/unsubscribe', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: savedSearchIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/saveSearch.js
// module id = 6Sk3
// module chunks = 57